// Character limits for search/social snippets. Shared by SEOHead and the
// static page generator so both emit the same lengths. Text is only
// shortened (on a word boundary), never rewritten.

export const SEO_LIMITS = {
  metaDescription: 155,
  ogTitle: 60,
  twitterTitle: 55,
  twitterDescription: 125,
} as const;

const BRAND_SUFFIX = /\s*[|–-]\s*Hair Art Clinics\s*$/i;

export const fitText = (text: string, max: number): string => {
  const clean = String(text ?? '').replace(/\s+/g, ' ').trim();
  if (clean.length <= max) return clean;
  const noBrand = clean.replace(BRAND_SUFFIX, '').trim();
  if (noBrand.length <= max) return noBrand;
  const cut = noBrand.slice(0, max - 1);
  const space = cut.lastIndexOf(' ');
  const base = (space > max * 0.5 ? cut.slice(0, space) : cut).replace(/[\s,;:.–|-]+$/, '');
  return `${base}…`;
};
